<div id="big-red-button-modal">
  <div class="dialog">
    <div class="title-container">
      <h6 class="title-large">
        <img src="../../../../../assets/icons/sign.svg" alt="sign in icon"> {{ 'BRBTitle' | translate }}
      </h6>
    </div>
    <div class="desc">
      <div class="terms-container">
        <p>
          <i>
            {{ 'BRBBody' | translate }}
          </i>
          <br>
          <br>
        </p>
      </div>
    </div>
    <div class="actions">

      <button *ngIf="!loading" class="confirm-btn" (click)="confirmAgreementsBRB()">
        {{ 'BRBButton' | translate }}
      </button>

      <button class="confirm-btn btn-spinner" *ngIf="loading">
        <mat-spinner [mode]="'indeterminate'" diameter="25"></mat-spinner>
      </button>
    </div>
  </div>
</div>
